import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";

export class BusinessCard extends React.Component {
  render() {
    const {
      loading,
      businessOptions,
      selectedBusiness,
      handleSubmitLogin,
      onDropChange
    } = this.props;

    return (
      <div className="login-page">
        <div className="ui-g">
          <div className="login-panel card">
            <div className="ui-g">
              <div className="ui-g-12">
                <img
                  src="/assets/layout/images/business/color-logo.png"
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
              <div className="ui-g-12" style={{ textAlign: "left" }}>
                <label htmlFor="selectedBusiness" className="input-label">
                  Select Business
                </label>
                <pr.Dropdown
                  id="selectedBusiness"
                  value={selectedBusiness}
                  options={businessOptions}
                  onChange={e => {
                    e.id = "selectedBusiness";
                    onDropChange(e);
                  }}
                  filter={true}
                  filterBy="label"
                  filterPlaceholder="Search"
                />
              </div>
              {selectedBusiness ? (
                <div className="ui-g-12">
                  <pr.Button
                    label="Sign In"
                    icon={loading ? "pi pi-spin pi-spinner" : "pi pi-sign-in"}
                    onClick={handleSubmitLogin}
                    style={{ width: "100%" }}
                  />
                  <label>
                    By clicking Sign In, you agree to our Terms and have read
                    and acknowledged our Privacy Statement.
                  </label>
                </div>
              ) : (
                <label />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/UI/BusinessCard.js